if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/* MDB: draft PDP preview bootstrap — no-op unless ?view=clean-box-draft / ?mdb_pdp=draft */
(function () {
  try {
    var params = new URLSearchParams(window.location.search || '');
    var view = (params.get('view') || '').toLowerCase();
    var flag = (params.get('mdb_pdp') || '').toLowerCase();
    var wants =
      view === 'clean-box-draft' ||
      view.indexOf('clean-box') !== -1 ||
      flag === 'draft' ||
      flag === '1';
    if (!wants || !/\/products\//.test(window.location.pathname)) return;
    if (window.__mdbPdpPreviewScript) return;
    window.__mdbPdpPreviewScript = true;
    var sample = document.querySelector(
      'script[src*="/cdn/shop/t/"][src*="/assets/"], link[href*="/cdn/shop/t/"][href*="/assets/"]'
    );
    // Prefer v3 (silk-matched type + head stylesheet move). Fallback name kept in sync-bust.
    var href = '/cdn/shop/t/28/assets/mdb-pdp-preview-v5.js';
    if (sample) {
      href = (sample.src || sample.href).replace(/\/assets\/[^/?#]+.*/, '/assets/mdb-pdp-preview-v5.js');
    }
    var s = document.createElement('script');
    s.src = href;
    s.defer = true;
    document.head.appendChild(s);
  } catch (e) {}
})();

/* MDB: keep Google badge bottom-aligned with Shopify Inbox Live chat */
(function () {
  if (window.__mdbGBadgeAlign) return;
  window.__mdbGBadgeAlign = true;

  function chatNode() {
    var host = document.querySelector('shopify-chat');
    if (host) {
      try {
        if (host.shadowRoot) {
          var inner =
            host.shadowRoot.querySelector('[part="button"], button, [role="button"], a') ||
            host.shadowRoot.querySelector('[class*="activator"], [class*="launcher"], [class*="button"]');
          if (inner) return inner;
        }
      } catch (e) {}
      return host;
    }
    return document.querySelector('#shopify-chat, [id*="ShopifyChat"]');
  }

  function ensureSoftStyle() {
    if (document.getElementById('mdb-g-badge-align')) return;
    var style = document.createElement('style');
    style.id = 'mdb-g-badge-align';
    style.textContent =
      '.mdb-g-badge{background:rgba(255,255,255,.92)!important;-webkit-backdrop-filter:saturate(1.2) blur(10px);backdrop-filter:saturate(1.2) blur(10px);border:1px solid rgba(0,0,0,.08);box-shadow:0 1px 6px rgba(0,0,0,.1)!important;' +
      'bottom:var(--shopify-chat-activator-offset,80px)!important;}';
    (document.head || document.documentElement).appendChild(style);
  }

  function align() {
    ensureSoftStyle();
    var badge = document.querySelector('[data-mdb-g-badge], .mdb-g-badge');
    if (!badge) return;
    var chat = chatNode();
    if (!chat) return;
    var rect = chat.getBoundingClientRect();
    if (rect.width < 4 || rect.height < 4 || rect.bottom < 0) return;
    var bottom = Math.max(0, Math.round(window.innerHeight - rect.bottom));
    badge.style.setProperty('bottom', bottom + 'px', 'important');
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      align();
    });
  }

  function boot() {
    align();
    var tries = 0;
    var tick = setInterval(function () {
      align();
      tries += 1;
      if (tries > 40) clearInterval(tick);
    }, 250);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(schedule).observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style'],
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


/* sync-bust badge-align 2026-08-03b */
